// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"5b303c04","513":"9497ae09","703":"89e75767"}[chunkId] + ".chunk.js";
};